
import {
  ROUTE_INDEX,
  // ROUTE_INTERNAL_LOTTO,
  // ROUTE_EXTERNAL_CASINO,
  // ROUTE_EXTERNAL_FOOTBALL,
  // ROUTE_EXTERNAL_SLOT,
  ROUTE_LIST,
  ROUTE_AFFILIATE,
  ROUTE_CASHBACK,
  ROUTE_COMMISSION,
  ROUTE_CONTACT,
  ROUTE_CREDIT,
  ROUTE_NEWS,
  // ROUTE_GAME_OTHERS,
  ROUTE_RESULT,
  ROUTE_SETTING,
  ROUTE_STATUS,
  ROUTE_TEMPLATE_NUMBER,
  ROUTE_TRASACTION,
  ROUTE_VOUCHER
} from './route'

const gameList = [
  {
    name: 'หน้าหลัก',
    pathName: ROUTE_INDEX,
    to: '/',
    imgWhite: require('@/assets/nav/submenu/icon_home.svg'),
    img: require('@/assets/v3/navbar/home.svg'),
    Isclosed: false,
    onlyUser: false
  },
  // {
  //   name:'หวยออนไลน์',
  //   imgBlack:require('@/assets/index/dollar-coin-money.svg'),
  //   imgWhite:require('@/assets/nav/submenu/icon_lotto.svg'),
  //   pathName:ROUTE_INTERNAL_LOTTO,
  //   to:'/lotto',
  //   Isclosed:false,
  //   onlyUser:false
  // },
  // {
  //   name:'คาสิโนออนไลน์',
  //   imgBlack:require('@/assets/index/dice.svg'),
  //   imgWhite:require('@/assets/nav/submenu/icon_submenu2.svg'),
  //   pathName:ROUTE_EXTERNAL_CASINO,
  //   to:'/casino',
  //   Isclosed:true,
  //   onlyUser:false
  // },
  // {
  //   name:'บอลออนไลน์',
  //   imgBlack:require('@/assets/index/football.svg'),
  //   imgWhite:require('@/assets/nav/submenu/icon_submenu16.svg'),
  //   pathName:ROUTE_EXTERNAL_FOOTBALL,
  //   to:'/football',
  //   Isclosed:true,
  //   onlyUser:false
  // },
  // {
  //   name:'สล็อตออนไลน์',
  //   imgBlack:require('@/assets/index/slot.svg'),
  //   imgWhite:require('@/assets/nav/submenu/icon_submenu15.svg'),
  //   pathName:ROUTE_EXTERNAL_SLOT,
  //   to:'/slot',
  //   Isclosed:true,
  //   onlyUser:false
  // },
  // {
  //   name:'พาวเวอร์บอล',
  //   imgBlack:require('@/assets/index/powerball.svg'),
  //   imgWhite:require('@/assets/nav/submenu/icon_power_ball.svg'),
  //   pathName:ROUTE_GAME_OTHERS,
  //   to:'/game-others',
  //   Isclosed:true,
  //   onlyUser:false
  // },
]

const menuList = [
  {
    name: 'รายการโพย',
    imgBlack: require('@/assets/index/icon_submenu5dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu5.svg'),
    img: require('@/assets/v3/navbar/list.svg'),
    to: '/list',
    pathName: ROUTE_LIST,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'ดูผลย้อนหลัง',
    imgBlack: require('@/assets/index/icon_submenu6dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu6.svg'),
    img: require('@/assets/v3/navbar/search-property.svg'),
    to: '/result',
    pathName: ROUTE_RESULT,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'รายงานเครดิต',
    imgBlack: require('@/assets/index/icon_submenu21dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu21.svg'),
    img: require('@/assets/v3/navbar/overview.svg'),
    to: '/credit',
    pathName: ROUTE_CREDIT,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'รายการฝาก-ถอน',
    imgBlack: require('@/assets/index/icon_submenu8dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu8.svg'),
    img: require('@/assets/v3/navbar/bank.svg'),
    to: '/transactions',
    pathName: ROUTE_TRASACTION,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'ระบบแนะนำ',
    imgBlack: require('@/assets/index/icon_submenu9dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu17.svg'),
    img: require('@/assets/v3/navbar/leaving-queue.svg'),
    to: '/referal',
    pathName: ROUTE_AFFILIATE,
    Isclosed: false,
    onlyUser: true
  },
  {
    name: 'สถานะและยอดเทิร์น',
    imgBlack: require('@/assets/index/icon_submenu18.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu18.svg'),
    img: require('@/assets/v3/navbar/power-bi.svg'),
    to: '/status',
    pathName: ROUTE_STATUS,
    Isclosed: false,
    onlyUser: true
  },
  {
    name: 'แคชแบค',
    imgBlack: require('@/assets/index/icon_submenu19.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu19.svg'),
    img: require('@/assets/v3/navbar/cash-in-hand.svg'),
    to: '/cashback-v2',
    pathName: ROUTE_CASHBACK,
    Isclosed: false,
    onlyUser: true
  },
  {
    name: 'เลขชุด',
    imgBlack: require('@/assets/index/icon_submenu10dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu10.svg'),
    img: require('@/assets/v3/navbar/new-copy.svg'),
    to: '/numberset',
    pathName: ROUTE_TEMPLATE_NUMBER,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'ข่าวสาร',
    imgBlack: require('@/assets/index/icon_submenu11dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu11.svg'),
    img: require('@/assets/v3/navbar/bookmark.svg'),
    to: '/news',
    pathName: ROUTE_NEWS,
    Isclosed: false,
    onlyUser: false
  },
  {
    name: 'รายงานค่าแนะนำ',
    imgBlack: require('@/assets/index/icon_submenu7dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu7.svg'),
    img: require('@/assets/v3/navbar/user-location.svg'),
    to: '/commission',
    pathName: ROUTE_COMMISSION,
    Isclosed: false,
    onlyUser: false
  },
  // {
  //   name: 'แทงตามเซียน',
  //   imgBlack: require('@/assets/index/icon_submenu15dark.svg'),
  //   imgWhite: require('@/assets/index/icon_submenu15white.svg'),
  //   to: null,
  //   pathName: null,
  //   Isclosed: true,
  //   newtab: true,
  //   onlyUser: false
  // },
  {
    name: 'ตั้งค่าบัญชี',
    imgBlack: require('@/assets/index/icon_submenu12dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu12.svg'),
    img: require('@/assets/v3/navbar/services.svg'),
    to: '/setting',
    pathName: ROUTE_SETTING,
    Isclosed: false,
    onlyUser: true
  },
  {
    name: 'ติดต่อบริษัท',
    to: '/contact',
    pathName: ROUTE_CONTACT,
    imgBlack: require('@/assets/index/icon_submenu9dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu9.svg'),
    img: require('@/assets/v3/navbar/messaging.svg'),
    Isclosed: false,
    onlyUser: true
  },
  {
    name: 'บัตรกำนัน',
    imgBlack: require('@/assets/index/icon_submenu20dark.svg'),
    imgWhite: require('@/assets/nav/submenu/icon_submenu20.svg'),
    img: require('@/assets/v3/navbar/paycheque.svg'),
    to: '/vouchers',
    pathName: ROUTE_VOUCHER,
    Isclosed: false,
    onlyUser: true
  },
]

export const menues = [].concat(gameList, menuList)
export const GAME_LIST = gameList
export const MENU_LIST = menuList